"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const onchainInteractionsPoolToken_1 = __importDefault(require("../onchainInteractionsPoolToken"));
class OnchainInteractionsCollateral extends onchainInteractionsPoolToken_1.default {
    constructor(interactionsLendingPool) {
        super();
        this.getLendingPool = () => this.lendingPool;
        this.getPoolToken = () => this.poolToken;
        this.getInteractions = () => this.lendingPool.getInteractions();
        this.getAccountCollateral = this.getAccountPoolToken;
        this.getRouterContract = () => this.lendingPool.getRouterContract();
        this.lendingPool = interactionsLendingPool;
        this.poolToken = interactionsLendingPool.getLendingPool().getCollateral();
    }
    getAccountPoolToken() {
        return this.lendingPool.getAccountLendingPool().getCollateral();
    }
    getPermitData(approvalType, amount, deadlineArg, callBack) {
        return __awaiter(this, void 0, void 0, function* () {
            this._getPermitData(approvalType, amount, deadlineArg, callBack);
        });
    }
    mint(amount, permitData, onTransactionHash) {
        return __awaiter(this, void 0, void 0, function* () {
            const { router, ptAddress, account, data, deadline } = yield this.getSendData(permitData);
            return this.send(router.methods.mintCollateral(ptAddress, amount, account, deadline, data), onTransactionHash);
        });
    }
    ;
}
exports.default = OnchainInteractionsCollateral;
